<ng-container *ngIf="mainForm !== undefined && controlName">

  <div *ngIf="!imgSrc && !defaultImageSrc && !fileImageSrc" style="display: inline-block;">
    <label for="{{ uploadId }}" class="btn btn_link btn_icon inputFile-label" svgIcon [icon]="'upload'">
      {{ buttonText | translate:{ maxWidth: maxWidth, maxHeight: maxHeight } }}
    </label>
  </div>

  <div class="inputFile {{layoutModifier}}">
    <div class="inputFile-image" *ngIf="fileImageSrc || imgSrc || defaultImageSrc">
      <img *ngIf="fileImageSrc" [src]="fileImageSrc">
      <img *ngIf="imgSrc && !fileImageSrc" [src]="imgSrc">
      <img *ngIf="!imgSrc && defaultImageSrc && !fileImageSrc" [src]="defaultImageSrc">
      <div *ngIf="(fileImageSrc || imgSrc) && openPreview.observed"
        class="inputFile-preview" (click)="onOpenPreview()" svgIcon [icon]="'external-link'"
      ></div>
    </div>

    <div class="inputFile-content">
      <label *ngIf="fileImageSrc || imgSrc || defaultImageSrc" for="{{ uploadId }}"
        class="btn btn_link btn_icon inputFile-label" [ngClass]="{ 'inputFile-disabled': disabled }" svgIcon [icon]="'upload'">
        {{ buttonText | translate:{ maxWidth: maxWidth, maxHeight: maxHeight } }}
      </label>

      <input [disabled]="disabled" type="file" id="{{ uploadId }}" [hidden]="true" (change)="upload($event)"
        accept="{{ mimeType }}">
      <div class="form-errorMsg" [ngStyle]="{'opacity': !mainForm.controls[this.controlName].valid ? 1 : 0}">
        <i class="form-errorIcon form-errorIcon_warning"></i>
        <div *ngIf="resourceType === 'Account' || resourceType === 'Branch'">
          {{ ('FORMS.ERROR.' + buttonText) | translate:{ maxWidth: maxWidth, maxHeight: maxHeight } }}
        </div>
        <div *ngIf="pdfErrorType">
          {{ ('FORMS.ERROR.SETTINGS.OFFER_TEMPLATE.' + pdfErrorType) | translate }}
        </div>
      </div>

    </div>

  </div>
</ng-container>
